import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "./header";
import {Link} from "react-router-dom";

export default function Checkout() {
  const history = useHistory();
  const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";
  const [cartItems, setCartItems] = useState([]);
  const [cartTotal, setCartTotal] = useState(0);
  const [saveAddress, setSaveAddress] = useState(false);
  const [savedAddress, setSavedAddress] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    companyAddress: "",
    country: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
  });
  const calculateTotal = useCallback((items) => {
    const total = items.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    setCartTotal(total);
  }, []);
  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (!token) {
      // navigate("/login", { state: { from: "/checkout" } });
      Swal.fire(
        "Login Required",
        "Please login to proceed to checkout.",
        "info"
      );
      return;
    }

    const userId = localStorage.getItem("currentUserId");
    const cartKey = `cart_${userId}`;
    const items = JSON.parse(localStorage.getItem(cartKey) || "[]");
    if (items.length === 0) {
      window.location.href = "/cart";
      return;
    }
    setCartItems(items);
    calculateTotal(items);

    // Fetch saved address
    // const fetchSavedAddress = async () => {
    //   try {
    //     const { data } = await axios.get(`${API_URL}/order/my-latest-address`, {
    //       headers: { Authorization: `Bearer ${token}` }
    //     });
    //     if (data && data.shipping_address) {
    //       setSavedAddress(data.shipping_address);
    //       setForm(data.shipping_address);
    //       setEditMode(false);
    //     } else {
    //       setEditMode(true);
    //     }
    //   } catch (error) {
    //     console.error("Failed to fetch saved address:", error);
    //     setEditMode(true);
    //   }
    // };

    // fetchSavedAddress();
  }, [history, calculateTotal]);

  const handleInput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSaveAddress = async () => {
    try {
      const token = localStorage.getItem("userToken");
      if (!token) {
        Swal.fire("Error", "Please login to save address", "error");
        return;
      }

      // Validate required fields
      const requiredFields = [
        "firstName",
        "lastName",
        "email",
        "phone",
        "country",
        "address1",
        "city",
        "state",
        "zip",
      ];
      const missingFields = requiredFields.filter((field) => !form[field]);

      if (missingFields.length > 0) {
        Swal.fire(
          "Error",
          `Please fill in all required fields: ${missingFields.join(", ")}`,
          "error"
        );
        return;
      }

      const response = await axios.post(
        `${API_URL}/orders/save-address`,
        {
          address: {
            ...form,
            isSaved: true,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        console.log("saved address:", response.data);
        setSavedAddress(response.data.shippingAddress);
        setEditMode(false);
        Swal.fire("Success", "Address saved successfully!", "success");
      }
    } catch (error) {
      console.error("Failed to save address:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to save address",
        "error"
      );
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (cartItems.length === 0) {
      Swal.fire("Error", "Your cart is empty.", "error");
      return;
    }

    if (saveAddress && !savedAddress) {
      await handleSaveAddress();
    }

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("userToken");
      const orderData = {
        items: cartItems.map((item) => ({
          product: item.productId,
          name: item.name,
          image: item.image,
          price: item.price,
          quantity: item.quantity,
          buyOrRent: item.type || "buy",
          rentalStartDate: item.rentalStartDate,
          rentalEndDate: item.rentalEndDate,
        })),
        shippingAddress: form,
        source: "sunrise-website",
      };

      const res = await axios.post(`${API_URL}/orders`, orderData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data && res.data.order) {
        const userId = localStorage.getItem("currentUserId");
        localStorage.removeItem(`cart_${userId}`);
        setOrderPlaced(true); // Add this line

        Swal.fire({
          title: "Success!",
          text: "Your order has been placed successfully!",
          icon: "success",
          confirmButtonText: "View Orders",
        }).then((result) => {
          if (result.isConfirmed) {
            history.push("/account");
          }
        });
      }
    } catch (error) {
      console.error("Order placement error:", error);
      Swal.fire("Error", "Failed to place order. Please try again.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="color-scheme-wrap active">
        <button className="switchIcon">
          <i className="fa-solid fa-palette"></i>
        </button>
        <h4 className="color-scheme-wrap-title">
          <i className="far fa-palette me-2"></i>Style Swicher
        </h4>
        <div className="color-switch-btns">
          <button data-color="#3E66F3">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#684DF4">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#008080">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#323F7C">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#FC3737">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#8a2be2">
            <i className="fa-solid fa-droplet"></i>
          </button>
        </div>
        <Link
          to="https://themeforest.net/user/themeholy"
          className="th-btn text-center w-100"
        >
          <i className="fa fa-shopping-cart me-2"></i> Purchase
        </Link>
      </div>
      {/* Preloader */}
      {/* <div className="preloader ">
        <button className="th-btn preloaderCls">Cancel Preloader </button>
        <div className="preloader-inner">
          <img src="assets/img/logo.svg" alt="img" />
          <div className="heart-rate">
            <img src="assets/img/shape/preloader.svg" alt="" />

            <div className="fade-in"></div>

            <div className="fade-out"></div>
          </div>
        </div>
      </div> */}
      {/* Sidemenu */}
      <div className="sidemenu-wrapper shopping-cart ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget woocommerce widget_shopping_cart">
            <h3 className="widget_title">Shopping cart</h3>
            <div className="widget_shopping_cart_content">
              <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_1.jpg"
                      alt="Cart Image1"
                    />
                    Puregen Labs Meclizine
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_2.jpg"
                      alt="Cart Image2"
                    />
                    Pranarom Pure Essential Oil
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_3.jpg"
                      alt="Cart Image3"
                    />
                    Pediatric Stethoscope
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $30.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_4.jpg"
                      alt="Cart Image4"
                    />
                    Puregen Labs Allergy Relief
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_5.jpg"
                      alt="Cart Image5"
                    />
                    Digital Thermometer
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.99
                    </span>
                  </span>
                </li>
              </ul>
              <p className="woocommerce-mini-cart__total total">
                <strong>Subtotal:</strong>
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  170.99
                </span>
              </p>
              <p className="woocommerce-mini-cart__buttons buttons btn-wrap">
                <Link to="cart.html" className="th-btn wc-forward">
                  View cart
                </Link>
                <Link to="checkout.html" className="th-btn checkout wc-forward">
                  Checkout
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Sidemenu */}
      <div className="sidemenu-wrapper ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget footer-widget mb-0">
            <div className="th-widget-about">
              <div className="about-logo">
                <Link to="index.html">
                  <img src="assets/img/logo.svg" alt="Medova " />
                </Link>
              </div>
              <p className="about-text">
                Medova is a convenience services to the adaptability, Spacious
                modern villa living room with centrally placed swimming pool
                blending indooroutdoor
              </p>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Recent Posts</h3>
            <div className="recent-post-wrap">
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-1.jpg"
                      alt="Blog Image1"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 02, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-2.jpg"
                      alt="Blog Image2"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 25, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-3.jpg"
                      alt="Blog Image3"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>26
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-4.jpg"
                      alt="Blog Image4"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>27
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Social Media:</h3>
            <div className="th-social">
              <Link to="https://facebook.com">
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link to="https://twitter.com">
                <i className="fab fa-twitter"></i>
              </Link>
              <Link to="https://pinterest.com">
                <i className="fab fa-pinterest-p"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-linkedin-in"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-instagram"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose">
          <i className="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i className="fal fa-search"></i>
          </button>
        </form>
      </div>
      {/* Mobile Menu */}
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle">
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="home-medical-clinic.html">
              <img src="assets/img/logo.svg" alt="Medova " />
            </Link>
          </div>

          <div className="th-mobile-menu">
            <ul>
              <li className="menu-item-has-children">
                <Link to="home-medical-clinic.html">Home</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Multipage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy.html">Home Physiotherapy</Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop.html">Home Medical Shop</Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="#">Onepage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic-op.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2-op.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care-op.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric-op.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology-op.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery-op.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy-op.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet-op.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist-op.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop-op.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="about.html">About Us</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Services</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="service.html">Services</Link>
                  </li>
                  <li>
                    <Link to="service-details.html">Service Details</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Pages</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Shop</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="shop.html">Shop</Link>
                      </li>
                      <li>
                        <Link to="shop-details.html">Shop Details</Link>
                      </li>
                      <li>
                        <Link to="cart.html">Cart Page</Link>
                      </li>
                      <li>
                        <Link to="checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="wishlist.html">Wishlist</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="doctor.html">Doctors</Link>
                  </li>
                  <li>
                    <Link to="doctor-details.html">Doctors Details</Link>
                  </li>
                  <li>
                    <Link to="case-studies.html">Case Studies</Link>
                  </li>
                  <li>
                    <Link to="case-studies-details.html">Case Studies Details</Link>
                  </li>
                  <li>
                    <Link to="appointment.html">Appointment</Link>
                  </li>
                  <li>
                    <Link to="pricing.html">Price Table</Link>
                  </li>
                  <li>
                    <Link to="error.html">Error Page</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Blog</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="#">Blog Layout</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="blog.html">Blog</Link>
                      </li>
                      <li>
                        <Link to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="blog-grid-sidebar.html">
                          Blog Grid With Sidebar
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-list.html">Blog List</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="blog-details.html">Blog Details</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Header Area */}
      <Header />
      {/* Breadcumb */}
      <div
        className="breadcumb-wrapper "
        data-bg-src="assets/img/bg/breadcumb-bg.jpg"
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Checkout</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Checkout</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Checkout Arae */}
      <div className="th-checkout-wrapper space-top space-extra-bottom">
        <div className="container">
          <form action="#" className="woocommerce-checkout mt-40">
            <div className="row ">
              <div className="col-lg-6">
                <h2 className="h4">Billing Details</h2>
                <div className="row">
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="firstName"
                      placeholder="First Name"
                      value={form.firstName || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      placeholder="Last Name"
                      value={form.lastName || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="Email Address"
                      value={form.email || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      maxLength="10"
                      placeholder="Phone number"
                      value={form.phone || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="company"
                      placeholder="Your Company Name"
                      value={form.company || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="companyAddress"
                      placeholder="Street Address"
                      value={form.companyAddress || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-12 form-group">
                    <select
                      className="form-select"
                      name="country"
                      onChange={handleInput}
                      value={form.country || ""}
                      required
                    >
                      <option value="">Select Country</option>
                      <option value="India">India</option>
                      <option value="Australia">Australia</option>
                      <option value="Canada">Canada</option>
                      <option value="China">China</option>
                      <option value="Morocco">Morocco</option>
                      <option value="Saudi Arabia">Saudi Arabia</option>
                      <option value="United Kingdom (UK)">
                        United Kingdom (UK)
                      </option>
                      <option value="United States (US)">
                        United States (US)
                      </option>
                    </select>
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="address1"
                      placeholder="House number and street name"
                      value={form.address1 || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="address2"
                      placeholder="Apartment, suite, unit etc. (optional)"
                      value={form.address2 || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-4 form-group">
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      placeholder="city"
                      value={form.city || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-4 form-group">
                    <input
                      type="text"
                      name="state"
                      className="form-control"
                      placeholder="state"
                      value={form.state || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-4 form-group">
                    <input
                      type="text"
                      name="zip"
                      className="form-control"
                      placeholder="zip"
                      value={form.zip || ""}
                      onChange={handleInput}
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group mb-3">
                    <textarea
                      name="notes"
                      placeholder="Notes about your order, e.g. special notes for delivery."
                      value={form.notes || ""}
                      onChange={handleInput}
                    />
                  </div>

                  <div className="col-12 form-group">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="saveAddressCheckbox"
                      checked={saveAddress}
                      onChange={(e) => setSaveAddress(e.target.checked)}
                    />
                    <label htmlFor="saveAddressCheckbox">Creat An Account?</label>
                  </div>
                  {saveAddress && (
                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn theme-btn-1 btn-effect-1 text-uppercase"
                        onClick={handleSaveAddress}
                      >
                        Save Address
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <p id="ship-to-different-address">
                  <input
                    id="ship-to-different-address-checkbox"
                    type="checkbox"
                    name="ship_to_different_address"
                    value="1"
                    checked
                  />
                  <label htmlFor="ship-to-different-address-checkbox">
                    Cart Totals
                    <span className="checkmark"></span>
                  </label>
                </p>
                <table className="table">
                  <tbody>
                    {cartItems.length === 0 ? (
                      <tr>
                        <td colSpan="2">Your cart is empty.</td>
                      </tr>
                    ) : (
                      cartItems.map((item, idx) => (
                        <tr key={idx}>
                          <td>
                            {item.name} <strong>× {item.quantity}</strong>
                          </td>
                          <td>₹{(item.price * item.quantity).toFixed(2)}</td>
                        </tr>
                      ))
                    )}
                    <tr>
                      <td>
                        <strong>Order Total</strong>
                      </td>
                      <td>
                        <strong>₹{cartTotal.toFixed(2)}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="ltn__checkout-payment-method mt-50">
                  <div className="ltn__payment-note mt-30 mb-30">
                    <p>
                      Your personal data will be used to process your order,
                      support your experience throughout this website, and for
                      other purposes described in our privacy policy.
                    </p>
                  </div>
                  <button
                    className="btn theme-btn-1 btn-effect-1 text-uppercase"
                    type="button"
                    onClick={handleSubmit}
                    disabled={isSubmitting || cartItems.length === 0}
                  >
                    {isSubmitting ? "Placing Order..." : "Place order"}
                  </button>
                </div>
              </div>
            </div>
          </form>
          {/* <h4 className="mt-4 pt-lg-2">Your Order</h4>
            <form action="#" className="woocommerce-cart-form">
                <table className="cart_table mb-20">
                    <thead>
                        <tr>
                            <th className="cart-col-image">Image</th>
                            <th className="cart-col-productname">Product Name</th>
                            <th className="cart-col-price">Price</th>
                            <th className="cart-col-quantity">Quantity</th>
                            <th className="cart-col-total">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="cart_item">
                            <td data-title="Product">
                                <Link className="cart-productimage" to="shop-details.html"><img width="91" height="91" src="assets/img/product/product_thumb_1_1.jpg" alt="Image"/></Link>
                            </td>
                            <td data-title="Name">
                                <Link className="cart-productname" to="shop-details.html">Gaming Computer</Link>
                            </td>
                            <td data-title="Price">
                                <span className="amount"><bdi><span>$</span>18</bdi></span>
                            </td>
                            <td data-title="Quantity">
                                <strong className="product-quantity">01</strong>
                            </td>
                            <td data-title="Total">
                                <span className="amount"><bdi><span>$</span>18</bdi></span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot className="checkout-ordertable">
                        <tr className="cart-subtotal">
                            <th>Subtotal</th>
                            <td data-title="Subtotal" colspan="4"><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">$</span>281.05</bdi></span></td>
                        </tr>
                        <tr className="woocommerce-shipping-totals shipping">
                            <th>Shipping</th>
                            <td data-title="Shipping" colspan="4"> Enter your address to view shipping options.
                            </td>
                        </tr>
                        <tr className="order-total">
                            <th>Total</th>
                            <td data-title="Total" colspan="4"><strong><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">$</span>281.05</bdi></span></strong>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </form> */}
          {/* <div className="mt-lg-3 mb-30">
                <div className="woocommerce-checkout-payment">
                    <ul className="wc_payment_methods payment_methods methods">
                        <li className="wc_payment_method payment_method_bacs">
                            <input id="payment_method_bacs" type="radio" className="input-radio" name="payment_method" value="bacs" checked="checked"/>
                            <label for="payment_method_bacs">Direct bank transfer</label>
                            <div className="payment_box payment_method_bacs">
                                <p>Make your payment directly into our bank account. Please use your Order ID as the payment reference. Your order will not be shipped until the funds have cleared in our account.
                                </p>
                            </div>
                        </li>
                        <li className="wc_payment_method payment_method_cheque">
                            <input id="payment_method_cheque" type="radio" className="input-radio" name="payment_method" value="cheque"/>
                            <label for="payment_method_cheque">Cheque Payment</label>
                            <div className="payment_box payment_method_cheque">
                                <p>Please send a check to Store Name, Store Street, Store Town, Store State / County, Store Postcode.</p>
                            </div>
                        </li>
                        <li className="wc_payment_method payment_method_cod">
                            <input id="payment_method_cod" type="radio" className="input-radio" name="payment_method"/>
                            <label for="payment_method_cod">Credit Cart</label>
                            <div className="payment_box payment_method_cod">
                                <p>Pay with cash upon delivery.</p>
                            </div>
                        </li>
                        <li className="wc_payment_method payment_method_paypal">
                            <input id="payment_method_paypal" type="radio" className="input-radio" name="payment_method" value="paypal"/>
                            <label for="payment_method_paypal">Paypal</label>
                            <div className="payment_box payment_method_paypal">
                                <p>Pay via PayPal; you can pay with your credit card if you don’t have a PayPal account.</p>
                            </div>
                        </li>
                    </ul>
                    <div className="form-row place-order">
                        <button type="submit" className="th-btn">Place order</button>
                    </div>
                </div>
            </div> */}
        </div>
      </div>
      {/* Footer Area */}
      <footer className="footer-wrapper footer-layout2">
        <div className="footer-top">
          <div className="container">
            <div className="row gy-4 justify-content-between align-items-center">
              <div className="col-lg-5">
                <div className="title-area mb-0 text-center text-lg-start">
                  <h2 className="sec-title text-white m-0">
                    Get a Free Consultation
                  </h2>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="footer-top-btn">
                  <div className="btn-group justify-content-center justify-content-lg-end">
                    <Link to="contact.html" className="th-btn style1">
                      Get a Free Consultaion{" "}
                      <i className="fa-light fa-arrow-right-long"></i>
                    </Link>
                    <Link to="contact.html" className="th-btn style3">
                      <img src="assets/img/icon/Playstore.svg" alt="" />
                      Download App
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="widget-area">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-6 col-xxl-3 col-xl-4">
                <div className="widget footer-widget">
                  <div className="th-widget-about">
                    <div className="about-logo">
                      <Link className="icon-masking" to="index.html">
                        <img src="assets/img/logo-white.svg" alt="Medova " />
                      </Link>
                    </div>
                    <p className="about-text">
                      Medova is a convenience services to the adaptability,
                      Spacious modern villa living room with centrally placed
                      swimming pool blending indooroutdoor
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Quick Links</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="about.html">About Us</Link>
                      </li>
                      <li>
                        <Link to="Services.html">Services</Link>
                      </li>
                      <li>
                        <Link to="contact.html">Our Staff</Link>
                      </li>
                      <li>
                        <Link to="contact.html">Term & Conditions</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Utility</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li>
                        <Link to="contact.html">Instructions</Link>
                      </li>
                      <li>
                        <Link to="contact.html">History</Link>
                      </li>
                      <li>
                        <Link to="contact.html">Patients Rights</Link>
                      </li>
                      <li>
                        <Link to="contact.html">Careers</Link>
                      </li>
                      <li>
                        <Link to="contact.html">Disclaimer</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Our Services</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li>
                        <Link to="service-details.html">Fitness Performance</Link>
                      </li>
                      <li>
                        <Link to="service-details.html">Support & Motivation</Link>
                      </li>
                      <li>
                        <Link to="service-details.html">Weight Loss Programs</Link>
                      </li>
                      <li>
                        <Link to="service-details.html">Personalized Plan</Link>
                      </li>
                      <li>
                        <Link to="service-details.html">Healthy Daily Life</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Support</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li>
                        <Link to="contact.html">Help Center</Link>
                      </li>
                      <li>
                        <Link to="faq.html">FAQs</Link>
                      </li>
                      <li>
                        <Link to="contact.html">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="contact.html">Ticket Support</Link>
                      </li>
                      <li>
                        <Link to="contact.html">Live Chat</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-xl-4">
                <div className="footer-widget-about">
                  <h3 className="box-title text-white">Find Us Here</h3>
                  <div className="th-widget-about">
                    <p className="footer-info">
                      <i className="fa-sharp fa-solid fa-phone"></i>
                      <span>
                        <Link className="text-inherit" to="tel:+00123456789012">
                          +00 (123) 456 789 012
                        </Link>
                      </span>
                    </p>
                    <p className="footer-info">
                      <i className="fa-sharp fa-solid fa-envelope"></i>
                      <span>
                        <Link
                          className="text-inherit"
                          to="mailto:infomail123@domain.com"
                        >
                          infomail123@domain.com
                        </Link>
                      </span>
                    </p>
                    <p className="footer-info">
                      <i className="fas fa-map-marker-alt"></i>West 2nd lane,
                      Inner circular road, New York City
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-8">
                <div className="footer-tags">
                  <div className="h4 text-white">Services Needed?</div>
                  <div className="tagcloud">
                    <Link to="service-details.html">Fitness</Link>
                    <Link to="service-details.html">Motivation</Link>
                    <Link to="service-details.html">Weight Loss</Link>
                    <Link to="service-details.html">Nutrition Plan</Link>
                    <Link to="service-details.html">Exercise</Link>
                    <Link to="service-details.html">Natural Foods</Link>
                    <Link to="service-details.html">Diet Control</Link>
                  </div>
                  <div className="btn-group">
                    <Link to="contact.html" className="th-btn style1">
                      Make Appointment{" "}
                      <i className="fa-light fa-arrow-right-long ms-2"></i>
                    </Link>
                    <div className="opening-hour">
                      <div className="icon">
                        <i className="fa-solid fa-clock"></i>
                      </div>
                      <div className="media-body">
                        <span className="label">Openning Hour</span>
                        <span className="time">09:30AM- 10:30PM</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row gy-2 justify-content-center justify-content-md-between align-items-center">
            <div className="col-md-7 col-lg-5 text-center text-md-start">
              <div className="social-links">
                <span className="title">Social Media:</span>
                <Link to="https://www.facebook.com/">
                  <i className="fab fa-facebook-f"></i>
                </Link>
                <Link to="https://www.twitter.com/">
                  <i className="fab fa-twitter"></i>
                </Link>
                <Link to="https://www.linkedin.com/">
                  <i className="fab fa-linkedin-in"></i>
                </Link>
                <Link to="https://www.whatsapp.com/">
                  <i className="fab fa-whatsapp"></i>
                </Link>
                <Link to="https://www.youtube.com/">
                  <i className="fab fa-youtube"></i>
                </Link>
              </div>
            </div>
            <div className="col-md-5 col-lg-7">
              <div className="call-info">
                <div className="call-info_icon">
                  <Link to="tel:0012345678900">
                    <img src="assets/img/icon/call.svg" alt="" />
                  </Link>
                </div>
                <div className="media-body">
                  <span className="call-info_label">DAILY 24H EMERGENCY</span>
                  <p className="call-info_link">
                    <Link to="tel:+0012345678900">+00 (123) 456789 00</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container">
            <div className="row gy-2 align-items-center">
              <div className="col-lg-5">
                <p className="copyright-text">
                  Copyright <i className="fal fa-copyright"></i> 2025{" "}
                  <Link to="https://themeforest.net/user/themeholy">Medova</Link>.
                  All Rights Reserved.
                </p>
              </div>
              <div className="col-lg-7 text-center text-lg-end">
                <div className="footer-links">
                  <ul>
                    <li>
                      <Link to="about.html">Terms of service</Link>
                    </li>
                    <li>
                      <Link to="about.html">Privacy policy</Link>
                    </li>
                    <li>
                      <Link to="about.html">Cookies</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
